module.exports = __webpack_public_path__ + "static/media/icon_table_tennis_ball.b394b195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_table_tennis_ball.png
// module id = 530
// module chunks = 0